module.exports = __webpack_public_path__ + "static/media/Postcard.72bbf058.jpg";